import axios from "axios";
import { IBookingsRceDashboardApiFilter } from "../types";
import { useMutation } from "@tanstack/react-query";
import { IBookingsApiFilter, ISortBy } from "../../../api/types";

type Props = {
    filters?: IBookingsApiFilter,
    sortBy?: ISortBy,
    start?: number,
    limit?: number,
}

export async function getRceDashboardList(props: Props) {
    if (!props.filters) {
        return null;
    }

    const resp = await axios.post("/booking/rce-dashoboard/v1/list", props);
    return resp.data;
}

export function useRceDashboardListMutation() {
    const mutation = useMutation(getRceDashboardList);
    return mutation;
}
